import {Component, input, output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Text} from '../text/text';
import {IconsComponent} from '../icons/icons.component';

@Component({
  selector: 'app-search',
  imports: [
    FormsModule,
    Text,
    IconsComponent
  ],
  templateUrl: './search.html',
  styleUrl: './search.css',
})
export class Search extends Text {
  override label = input<string>('Search');
  button = input<boolean>(false);

  search = output<string | undefined>();
}
